import LinkButton from '~/components/button/LinkButton';
import Page from '~/components/layout/page/Page';
import Link from '~/components/Link';
import { useLoaderData } from './shippingProtection';

export default function ShippingProtection() {
  const { shippingProtectionUrl, reasonId } = useLoaderData();

  return (
    <Page.Section className="mb-8" title="Quickly Resolve Your Shipping Issue">
      <div className="flex flex-col gap-6">
        <p>
          This order has shipping protection for moments like this. If your
          package was lost, stolen, or damaged in transit, you can simply
          request a replacement.
        </p>
        <div className="mt-4 flex flex-col gap-4">
          <LinkButton
            className="md:w-1/2"
            variant="filled"
            to={shippingProtectionUrl}
          >
            Request Replacement
          </LinkButton>
          <Link to={`../reason/${reasonId}`}>Or continue with return</Link>
        </div>
      </div>
    </Page.Section>
  );
}
